type MapRootProps = {
  children: React.ReactNode;
};

function MapRoot({ children }: MapRootProps) {
  return (
    <div className={`flex flex-col h-full w-full relative`}>{children}</div>
  );
}

export default MapRoot;
